const groups = {
  general: "General",
  planAPI11: "Plan API 11",
  planAPI23: "Plan API 23",
  planAPI32: "Plan API 32",
  planAPI52: "Plan API 52",
  planAPI53b: "Plan API 53b",
  planAPI54: "Plan API 54",
  flame: "Calidad de Llama",
  "Cooling Lubricant": "Lubricante de Enfriamiento",
  steps: "Seleccionables"
};
export default groups;
